import { Gateway, GatewayDetail } from '@/entities/gateway';

export function intoEditable(data: GatewayDetail): Gateway {
  return {
    ...data.data,
    entityItem: data.data.entityItem?.id ?? null,
  };
}
